import { createContext, type ReactNode, useContext } from "react";

export interface FeatureFlags {
	/** Gate for all MVP-phase features. Set VITE_FEATURE_MVP=true to enable. */
	A2A_AGENTS_DISABLED: boolean;
	/** Keeps the first-run welcome wizard and nav tour from auto-opening. See common/onboarding.ts. */
	ONBOARDING_DISABLED: boolean;
}

const DEFAULT_FLAGS: FeatureFlags = {
	A2A_AGENTS_DISABLED: false,
	ONBOARDING_DISABLED: false,
};

const FlagsContext = createContext<FeatureFlags>(DEFAULT_FLAGS);

export function FlagsProvider({
	children,
	flags = DEFAULT_FLAGS,
}: {
	children: ReactNode;
	flags?: Partial<FeatureFlags>;
}) {
	return (
		<FlagsContext.Provider value={{ ...DEFAULT_FLAGS, ...flags }}>
			{children}
		</FlagsContext.Provider>
	);
}

export function useFlag<K extends keyof FeatureFlags>(flag: K): boolean {
	return useContext(FlagsContext)[flag];
}
